import { NgModule } from '@angular/core';

import { LenderRoutingModule } from './lender-routing.module';
@NgModule({
  declarations: [
  ],
  imports: [
    LenderRoutingModule,
  ],
  exports: [
  ]
})
export class LenderModule { }
